module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "level"
  }, [_c('div', {
    staticClass: "level-left"
  }, [_c('div', {
    staticClass: "level-item"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('p', [_c('router-link', {
    staticClass: "button is-info",
    attrs: {
      "to": '/clients/create'
    }
  }, [_vm._v("Create new application")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "level-right"
  }, [_c('div', {
    staticClass: "level-item"
  }, [_c('p', [_vm._v("Total: "), _c('strong', [_vm._v(_vm._s(_vm._f("numberDisplay")(this.$store.state.clientsTotal)))]), _vm._v(" applications")])]), _vm._v(" "), _c('div', {
    staticClass: "level-item"
  }, [_c('div', {
    staticClass: "field has-addons"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchValue),
      expression: "searchValue"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Find by"
    },
    domProps: {
      "value": (_vm.searchValue)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.searchClients($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchValue = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchKey),
      expression: "searchKey"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.searchKey = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "name"
    }
  }, [_vm._v("name")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "package_name"
    }
  }, [_vm._v("package")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "platform"
    }
  }, [_vm._v("platform")])])])]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.searchClients
    }
  }, [_vm._v("Search")])])])])])]), _vm._v(" "), _c('pagination', {
    staticClass: "is-small",
    attrs: {
      "urlBuilder": _vm.buildPaginatorUrls,
      "currentPage": _vm.currentPage,
      "lastPage": _vm.lastPage,
      "displayPage": 5
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table is-striped is-fullwidth"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [(!this.$store.state.clients.length) ? _c('tr', [_c('td', {
    staticClass: "has-text-centered has-text-grey",
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v("No clients found")])]) : _vm._e(), _vm._v(" "), _vm._l((this.$store.state.clients), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": ("/clients/" + (item.id))
      }
    }, [_vm._v(_vm._s(item.name))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.package_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.platform))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.devices_count))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.cameras_count))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.created_at))])])
  })], 2)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Package name")]), _vm._v(" "), _c('th', [_vm._v("Platform")]), _vm._v(" "), _c('th', [_vm._v("Devices")]), _vm._v(" "), _c('th', [_vm._v("Cameras")]), _vm._v(" "), _c('th', [_vm._v("Created at")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f4a1a09e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Clients/ClientList.vue
// module id = 358
// module chunks = 1